export interface BuildingModel {
  altitude: string;
  cantonCode: string;
  countryISOCode: string;
  forAddress: string;
  fullAddress: string;
  houseNumber: string;
  id: string;
  place: string;
  postalCode: string;
  street: string;
  streetSecondLine: string;
}
